export const NAVIGATION = {
  ASSTE_DETAILS: '/asset-details',
};